import { render, staticRenderFns } from "./WhatIfScenarioReview.vue?vue&type=template&id=19bda488&"
import script from "./WhatIfScenarioReview.vue?vue&type=script&lang=js&"
export * from "./WhatIfScenarioReview.vue?vue&type=script&lang=js&"
import style0 from "./WhatIfScenarioReview.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports